(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emylia-services"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('emylia-market-estimate')) {
  const usd = new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: 0
  });
  customElements.define('emylia-market-estimate', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('input', this.update);
      this.frame = requestAnimationFrame(() => {
        this.querySelector('fieldset').disabled = false;
        this.update();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.removeEventListener('input', this.update);
    }
    update() {
      const values = {};
      for (const slider of this.querySelectorAll('input[type="range"]')) {
        const { name, valueAsNumber: value } = slider;
        values[name] = value;
        let display = String(value);
        if (name === 'missed' || name === 'close') display += '%';
        if (name === 'value') display = usd.format(value);
        this.querySelector('[data-value="' + name + '"]').textContent = display;
        slider.setAttribute('aria-valuetext', display);
      }
      const jobs = values.leads * values.missed * values.close / 10000;
      const revenue = jobs * values.value;
      this.querySelector('[data-total="jobs"]').textContent = String(Math.round(jobs));
      this.querySelector('[data-total="month"]').textContent = usd.format(revenue);
      this.querySelector('[data-total="year"]').textContent = usd.format(12 * revenue);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
